import axios from 'axios'
import config from './config'
import { message } from 'antd'
import store from '@/store'

const isDev = process.env.NODE_ENV === 'development'
let URL_PREFIX = config.API_PRO
if (isDev) URL_PREFIX = config.API_DEV

const methods = {
  async POST (url, reqData) {
    const requestData = {
      url: `${URL_PREFIX}${url}`,
      method: 'post',
      data: reqData,
      headers: {}
    }

    if (store.getState().user) {
      requestData.headers['admin-id'] = store.getState().user.id
    }

    const { data } = await axios(requestData)

    if (data.code !== 200) {
      let errorTips = '网络错误'

      if (data.result && typeof data.result === 'string') {
        errorTips = data.result
      }
      message.error(errorTips)
    }

    return data
  }
}

const ApisInfo = {
  HOST: URL_PREFIX,
}

// ---------------业务接口
const services = [
  'admin',
  'note',
  'book',
  'category',
  'order',
  'article',
  'comment',
  'upload'
]

let allApis

services.map(value => {
  const mo = require('./service/' + value)
  allApis = {
    ...allApis,
    ...mo.default(methods),
    ApisInfo
  }
  // allApis = Object.assign(mo.default(methods), ApisInfo)
})

export default allApis
